import { Vendor } from "../../types/VendorTypes";

/**
 * Query params that pre-fill the buyer brief wizard when it is opened from
 * somewhere that already knows the vendor, e.g. a deal analysis project.
 *
 * Query params rather than router state because that is the idiom in this app
 * (see VendorsView); nothing here uses navigate(path, { state }).
 *
 * Producer and consumer both live here so the param names cannot drift apart.
 */
const PARAM_VENDOR_KEY = "vendorKey";
const PARAM_VENDOR_NAME = "vendorName";
const PARAM_VENDOR_WEBSITE = "vendorWebsite";

export interface BriefIntakeSeed {
    supplierName: string;
    supplierWebsite: string;
    vendorKey?: string;
}

export function buildBriefIntakePath(vendor: Pick<Vendor, "vendorKey" | "name" | "url">): string {
    const params = new URLSearchParams();
    params.set(PARAM_VENDOR_NAME, vendor.name);
    if (vendor.vendorKey) params.set(PARAM_VENDOR_KEY, vendor.vendorKey);
    // The vendor field is `url`, not `website`.
    if (vendor.url) params.set(PARAM_VENDOR_WEBSITE, vendor.url);
    return `/briefs?${params.toString()}`;
}

/** Returns undefined when the params carry no vendor name, i.e. a normal visit. */
export function readBriefIntakeSeed(params: URLSearchParams): BriefIntakeSeed | undefined {
    const supplierName = params.get(PARAM_VENDOR_NAME);
    if (!supplierName) return undefined;
    return {
        supplierName,
        supplierWebsite: params.get(PARAM_VENDOR_WEBSITE) || "",
        vendorKey: params.get(PARAM_VENDOR_KEY) || undefined,
    };
}
